import { MapPin, Phone, Mail, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* About */}
          <div>
            <h3 className="font-heading text-2xl mb-4 text-accent">Cabanas Meio do Mato</h3>
            <p className="text-sm text-white/80 leading-relaxed mb-3">
              Refúgio exclusivo em meio à Mata Atlântica na Barra de Guaratiba, Rio de Janeiro.
              Cabanas de vidro com piscinas privativas para momentos inesquecíveis.
            </p>
            <p className="text-xs text-white/60">
              CNPJ: 42.314.805/0001-50
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-accent">Contato</h4>
            <div className="space-y-3">
              <a 
                data-testid="footer-phone-link"
                href="https://wa.me/5521996273547" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-sm text-white/80 hover:text-accent transition-colors"
              >
                <Phone size={18} className="flex-shrink-0 mt-0.5" />
                <span>(21) 99627-3547</span>
              </a>
              <a 
                data-testid="footer-email-link"
                href="mailto:reservacabanasmeiodomato@gmail.com"
                className="flex items-start gap-3 text-sm text-white/80 hover:text-accent transition-colors"
              >
                <Mail size={18} className="flex-shrink-0 mt-0.5" />
                <span>reservacabanasmeiodomato@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-white/80">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                <span>
                  Estr. Roberto Burle Marx, 2069<br />
                  Barra de Guaratiba, Rio de Janeiro - RJ<br />
                  23020-040
                </span>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-accent">Links Rápidos</h4>
            <div className="space-y-2">
              <button
                data-testid="footer-accommodations-link"
                onClick={() => document.getElementById('accommodations')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-white/80 hover:text-accent transition-colors"
              >
                Acomodações
              </button>
              <button
                data-testid="footer-booking-link"
                onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-white/80 hover:text-accent transition-colors"
              >
                Reservar
              </button>
              <button
                data-testid="footer-faq-link"
                onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-sm text-white/80 hover:text-accent transition-colors"
              >
                FAQ
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Cabanas Meio do Mato. Todos os direitos reservados.
          </p>
          <p className="text-xs text-white/40">
            Desenvolvido com cuidado para proporcionar a melhor experiência.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;